import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSolarSystemInfoThunk } from "./ourProjects.actions";

export const getSolarSystemInfo = createAsyncThunk(
  "ourProjects/getSolarSystemInfo",
  getSolarSystemInfoThunk
);

export const ourProjectsInitialState = {
  //   list: {
  //     data: [],
  //     totalItems: null,
  //     totalPages: null,
  //   },
  solarSystemInfo: {
    is_fetch: false,
    data: {},
  },
};

const OurProjectsSlice = createSlice({
  name: "ourProjects",
  initialState: ourProjectsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSolarSystemInfo.fulfilled, (state, { payload }) => {
        return { ...state, solarSystemInfo: { is_fetch: true, data: payload } };
      })
      .addCase(getSolarSystemInfo.pending, (state) => {
        return {
          ...state,
          solarSystemInfo: { ...state.solarSystemInfo, is_fetch: false },
        };
      })
      .addCase(getSolarSystemInfo.rejected, (state) => {
        return {
          ...state,
          solarSystemInfo: { is_fetch: false, data: {} },
        };
      });
  },
});

export default OurProjectsSlice.reducer;
